/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const favoriteTokens = {
  OutlineOffset: '2px',
  OutlineWidth: '2px',
  OutlineStyle: 'solid',
  OutlineColor: '#285da3',
  Disabled: '#dedfdf',
  LightBorder: '#232b2b',
  LightFillInitial: 'rgba(0, 0, 0, 0)',
  LightFillHover: '#a7aaaa',
  LightFillPressed: '#394040',
  LightFillSelected: '#000000',
  DarkBorder: '#c4c4c4',
  DarkFillInitial: 'rgba(0, 0, 0, 0)',
  DarkFillHover: '#c4c4c4',
  DarkFillPressed: '#656b6b',
  DarkFillSelected: '#ffffff',
  DarkDisabled: '#394040',
  DarkOutlineColor: '#285da3',
} as const;
